import React from 'react';
import { connect } from 'react-redux';
import classes from './TravellerSelection.scss';

import ChildSelection from '../ChildSelection/ChildSelection';

import { removeHotelRoom, setSlideLeft, setSlideRight, setInfant } from '../../../store/actions/index';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const travellerSelection = (props) => {

    const {slideCounter, type, lob, number, active} = {...props}

    let childSelection = [];
    if (type === 'child' && number > 0 && lob === 'hotel') {
        for (let i = 0; i < number; i++) {
            childSelection.push(<ChildSelection key={i} index={i + 1} roomIndex={props.roomindex} childrenage={props.childrenage[i]}/>);
        }
    }

    let controls = [
        { label: 0 },
        { label: 1 },
        { label: 2 },
        { label: 3 },
        { label: 4 },
        { label: 5 },
        { label: 6 },
        { label: 7 },
        { label: 8 },
        { label: 9 }
    ];

    if (lob === 'hotel') {
        controls = [
            { label: 0 },
            { label: 1 },
            { label: 2 },
            { label: 3 },
            { label: 4 }
        ];  
    }

    const colorDark = 'var(--color-grey-dark-1)';

    return (
        <div style={{ display: active ? 'block': 'none' }}>
            <div style={{ display: active ? 'block': 'none' }} className="u-relative">
                <div className={classes.Box}>
                    {controls.map(ctrl => {
                        if (type === 'adult' && ctrl.label === 0) return null;
                        if(props.adultActive) {
                            if(ctrl.label + parseInt(props.child, 10) > 9) {
                                return <label 
                                    key={ctrl.label}
                                    className={classes.ButtonDisabled}
                                    style={{
                                        transform: 'translateX(' + (slideCounter * 3)  + 'rem)'
                                    }}>
                                    <span className={`u-block`}>{ctrl.label}</span>
                                        <input
                                            type="radio" 
                                            value={ctrl.label}
                                            name={props.type}
                                            className="u-hide"
                                            onChange={props.clicked}
                                            readOnly
                                            />
                                </label>
                            } else {
                                return <label 
                                    key={ctrl.label}
                                    className={`${ctrl.label === parseInt(number,10) ? 'u-textColorWhite' : 'u-textColorDark'} ${ctrl.label === parseInt(number,10) ? 'u-backgroundColorPrimary' : 'u-backgroundColorWhite'} ${ctrl.label === parseInt(number,10) ? 'u-borderTransparent' : 'u-borderNormal'} ${classes.Button}`}
                                    style={{
                                        transform: 'translateX(' + (slideCounter * 3)  + 'rem)'
                                    }}>
                                    <span className={`u-block`}>{ctrl.label}</span>
                                        <input
                                            type="radio" 
                                            value={ctrl.label}
                                            name={props.type}
                                            className="u-hide"
                                            onChange={props.clicked}
                                            readOnly
                                            />
                                </label>
                            }
                        }
                        if(props.childActive) {
                            if(ctrl.label + parseInt(props.adult, 10) > 9) {
                                return <label 
                                    key={ctrl.label}
                                    className={classes.ButtonDisabled}
                                    style={{
                                        transform: 'translateX(' + (slideCounter * 3)  + 'rem)'
                                    }}>
                                    <span className={`u-block`}>{ctrl.label}</span>
                                        <input
                                            type="radio" 
                                            value={ctrl.label}
                                            name={props.type}
                                            className="u-hide"
                                            onChange={props.clicked}
                                            readOnly
                                            />
                                </label>
                            } else {
                                return <label 
                                    key={ctrl.label}
                                    className={`${ctrl.label === parseInt(number,10) ? 'u-textColorWhite' : 'u-textColorDark'} ${ctrl.label === parseInt(number,10) ? 'u-backgroundColorPrimary' : 'u-backgroundColorWhite'} ${ctrl.label === parseInt(number,10) ? 'u-borderTransparent' : 'u-borderNormal'} ${classes.Button}`}
                                    style={{
                                        transform: 'translateX(' + (slideCounter * 3)  + 'rem)'
                                    }}>
                                    <span className={`u-block`}>{ctrl.label}</span>
                                        <input
                                            type="radio" 
                                            value={ctrl.label}
                                            name={props.type}
                                            className="u-hide"
                                            onChange={props.clicked}
                                            readOnly
                                            />
                                </label>
                            }
                        }
                        if(props.infantActive) {
                            if(ctrl.label > parseInt(props.adult, 10)) {
                                return <label 
                                    key={ctrl.label}
                                    className={classes.ButtonDisabled}
                                    style={{
                                        transform: 'translateX(' + (slideCounter * 3)  + 'rem)'
                                    }}>
                                    <span className={`u-block`}>{ctrl.label}</span>
                                        <input
                                            type="radio" 
                                            value={ctrl.label}
                                            name={props.type}
                                            className="u-hide"
                                            onChange={props.clicked}
                                            readOnly
                                            />
                                </label>
                            } else {
                                return (
                                    <label 
                                        key={ctrl.label}
                                        className={`${ctrl.label === parseInt(number,10) ? 'u-textColorWhite' : 'u-textColorDark'} ${ctrl.label === parseInt(number,10) ? 'u-backgroundColorPrimary' : 'u-backgroundColorWhite'} ${ctrl.label === parseInt(number,10) ? 'u-borderTransparent' : 'u-borderNormal'} ${classes.Button}`}
                                        style={{
                                            transform: 'translateX(' + (slideCounter * 3)  + 'rem)'
                                        }}>
                                        <span className={`u-block`}>{ctrl.label}</span>
                                            <input
                                                type="radio" 
                                                value={ctrl.label}
                                                name={props.type}
                                                className="u-hide"
                                                onChange={props.clicked}
                                                readOnly
                                                />
                                    </label>
                                );
                            }
                        }
                    })}
                </div>
                { slideCounter > -6 && lob === 'flight' ? <div className={classes.ArrowRight} onClick={() => props.onSetSlideRight()}><FontAwesomeIcon icon="angle-right" color={`${colorDark}`} size="lg" /></div> : null }
                { slideCounter < 0 && lob === 'flight' ? <div className={classes.ArrowLeft} onClick={() => props.onSetSlideLeft()}><FontAwesomeIcon icon="angle-left" color={`${colorDark}`} size="lg" /></div> : null }
                { type === 'child' && number > 0 ? <div className={`u-flex f-wrap pl-2 pt-2 pr-2`}>{childSelection}</div> : null }
            </div>
        </div>
    );
}

const mapStateToProps = state => {
    return {
        slideCounter: state.ui.slideCounter,
        adultActive: state.travellers.adultActive,
        childActive: state.travellers.childActive,
        infantActive: state.travellers.infantActive,
        adult: state.travellers.adult,
        child: state.travellers.child,
        infant: state.travellers.infant
    }
}

const mapDispatchToProps = dispatch => {
    return {
        onRemoveHotelRoom: (value) => dispatch(removeHotelRoom(value)),
        onSetSlideLeft: () => dispatch(setSlideLeft()),
        onSetSlideRight: () => dispatch(setSlideRight()),
        onSetInfant: (value) => dispatch(setInfant(value)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(travellerSelection);


// WEBPACK FOOTER //
// ./src/components/Travellers/TravellerSelection/TravellerSelection.js